import type { ReactNode } from "react";

export function LegalPage({ title, lastUpdated, children }: { title: string; lastUpdated: string; children: ReactNode }) {
  return (
    <main className="mx-auto max-w-3xl px-4 py-10 sm:px-6 sm:py-14">
      <header className="border-b-4 border-double border-ink pb-3">
        <h1 className="text-[26px] leading-tight font-black tracking-tight sm:text-3xl">{title}</h1>
        <p className="mt-1 font-mono text-[12px] font-bold text-ink-3">{lastUpdated}</p>
      </header>
      <div className="mt-8 space-y-7">{children}</div>
    </main>
  );
}

export function Section({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section>
      <h2 className="border-l-4 border-shu pl-2 text-[15px] font-black">{title}</h2>
      <p className="mt-2 font-mincho text-[14px] leading-7 text-ink-2">{children}</p>
    </section>
  );
}
